import { render, staticRenderFns } from "./pgcManage.vue?vue&type=template&id=2c4a34dd&scoped=true"
import script from "./pgcManage.vue?vue&type=script&lang=js"
export * from "./pgcManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a34dd",
  null
  
)

export default component.exports